import React, { useEffect, useState } from "react";
import {
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Paper,
  Divider,
  Button, 
  Stack,
} from "@mui/material";
import { ExpandMoreRounded, HelpOutlineRounded } from "@mui/icons-material";

import WhatsApp from "@mui/icons-material/WhatsApp";
import EmailOutlined from "@mui/icons-material/EmailOutlined";

const faqData = [
  {
    id: "panel1",
    question: "ساعات پاسخگویی پشتیبانی زومیو چگونه است؟",
    answer:
      "پشتیبانی زومیو در تمامی روزهای کاری از ساعت 9 صبح الی 6 بعد از ظهر پاسخگوی سوالات شما مشتریان عزیز می‌باشد.",
  },

  {
    id: "panel2",
    question: "آیا قیمت‌ها و موجودی کالاها در زومیو به‌روز هستند؟",
    answer:
      "قیمت‌ها و موجودی درج‌شده در سایت ممکن است تغییر کنند. بنابراین، لطفاً پیش از پرداخت، از طریق ثبت درخواست استعلام، قیمت نهایی و موجودی کالا را تأیید کنید. پرداخت و ثبت نهایی سفارش باید پس از تأیید قیمت و موجودی انجام شود.",
  },
];

export default function FAQAccordion() {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    document.title = "پرسش های متداول | زومیو";
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // WhatsAppSupport
  const handleWhatsAppSupport = () => {
    const waShortLink = "https://wa.me/message/LNAEOJV5FWMQI1";
    window.open(waShortLink, "_blank", "noopener,noreferrer");
  };
  
  // Support Email 
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL;

  return (
    <Container
      maxWidth="md"
      sx={{
        py: { xs: 3, sm: 4, md: 6 },
        direction: "rtl",
      }}
    >
      {/* PAGE HEADER */}
      <Box sx={{ mb: { xs: 3, md: 4 } }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            mb: 1.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 48,
              height: 48,
              flexShrink: 0,
              borderRadius: 2.5,
              bgcolor: "#fff0f2",
              color: "#ef4056",
            }}
          >
            <HelpOutlineRounded sx={{ fontSize: 27 }} />
          </Box>

          <Box>
            <Typography
              variant="h5"
              component="h1"
              fontWeight={800}
              color="text.primary"
              sx={{
                fontSize: { xs: "1.25rem", sm: "1.6rem" },
                lineHeight: 1.6,
              }}
            >
              سوالات متداول
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ lineHeight: 1.8 }}
            >
              پاسخ پرسش‌های پرتکرار درباره خدمات زومیو
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ lineHeight: 2, mt: 2 }}
        >
          پاسخ سوالات خود درباره پشتیبانی، قیمت محصولات، ارسال سفارش و شرایط
          بازگشت کالا را در این بخش پیدا کنید.
        </Typography>
      </Box>

      {/* FAQ LIST */}
      <Box
        component="section"
        aria-label="پرسش‌ها و پاسخ‌های متداول"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
        }}
      >
        {faqData.map((item, index) => {
          const isExpanded = expanded === item.id;
          const questionId = `${item.id}-question`;
          const answerId = `${item.id}-answer`;

          return (
            <Accordion
              key={item.id}
              expanded={isExpanded}
              onChange={handleChange(item.id)}
              disableGutters
              elevation={0}
              sx={{
                overflow: "hidden",
                border: "1px solid",
                borderColor: isExpanded ? "#f1b7c0" : "grey.200",
                borderRadius: "14px !important",
                bgcolor: isExpanded ? "#fffafb" : "#fff",
                transition:
                  "border-color 0.2s ease, background-color 0.2s ease",
                "&:before": {
                  display: "none",
                },
                "&:hover": {
                  borderColor: isExpanded ? "#f1b7c0" : "grey.300",
                },
                "&.Mui-expanded": {
                  margin: 0,
                },
              }}
            >
              <AccordionSummary
                id={questionId}
                aria-controls={answerId}
                expandIcon={
                  <ExpandMoreRounded
                    sx={{
                      fontSize: 25,
                      color: isExpanded ? "#ef4056" : "text.secondary",
                      transition: "color 0.2s ease",
                    }}
                  />
                }
                sx={{
                  px: { xs: 2, sm: 2.5 },
                  py: 1,
                  minHeight: 68,
                  "&.Mui-expanded": {
                    minHeight: 68,
                  },
                  "& .MuiAccordionSummary-content": {
                    my: 1.5,
                    alignItems: "center",
                    gap: 1.5,
                    minWidth: 0,
                  },
                  "& .MuiAccordionSummary-content.Mui-expanded": {
                    my: 1.5,
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    flexShrink: 0,
                    mr: 1,
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 32,
                    height: 32,
                    flexShrink: 0,
                    borderRadius: 2,
                    bgcolor: isExpanded ? "#fde8ec" : "grey.100",
                    color: isExpanded ? "#ef4056" : "text.secondary",
                    fontSize: "0.8rem",
                    fontWeight: 800,
                    transition: "background-color 0.2s ease, color 0.2s ease",
                  }}
                >
                  {(index + 1).toLocaleString("fa-IR")}
                </Box>

                <Typography
                  component="span"
                  variant="body1"
                  fontWeight={isExpanded ? 800 : 700}
                  color="text.primary"
                  sx={{
                    flex: 1,
                    minWidth: 0,
                    textAlign: "right",
                    lineHeight: 1.9,
                    fontSize: { xs: "0.87rem", sm: "0.95rem" },
                  }}
                >
                  {item.question}
                </Typography>
              </AccordionSummary>

              <AccordionDetails
                id={answerId}
                aria-labelledby={questionId}
                sx={{
                  px: { xs: 2, sm: 2.5 },
                  pt: 0,
                  pb: { xs: 2.5, sm: 3 },
                }}
              >
                <Divider
                  sx={{
                    mb: 2,
                    borderColor: "rgba(0,0,0,0.06)",
                  }}
                />

                <Box
                  sx={{
                    pr: { xs: 0, sm: 1 },
                    mr: { xs: 0, sm: "43px" },
                  }}
                >
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      fontSize: { xs: "0.85rem", sm: "0.92rem" },
                      lineHeight: 2.2,
                      whiteSpace: "pre-line",
                    }}
                  >
                    {item.answer}
                  </Typography>
                </Box>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>

      {/* FOOTER NOTE */}
   
<Paper
  elevation={0}
  sx={{
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mt: 3,
    p: { xs: 2.5, sm: 3 },
    borderRadius: 3,
    border: "1px solid",
    borderColor: "grey.200",
    bgcolor: "#fff",
  }}
>
  <Box>
    <Typography
      variant="subtitle1"
      fontWeight={800}
      color="text.primary"
      sx={{ mb: 0.5 }}
    >
      پاسخ سوال خود را پیدا نکردید؟
    </Typography>

    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ lineHeight: 1.9 }}
    >
      برای دریافت راهنمایی بیشتر، از طریق واتساپ یا ایمیل با پشتیبانی زومیو در ارتباط باشید.
    </Typography>
  </Box>

  <Stack
    direction={{ xs: "column", sm: "row" }}
    sx={{
      width: "100%",
      gap: 1,
    }}
  >
    <Button
      fullWidth
      variant="contained"
      onClick={handleWhatsAppSupport}
      startIcon={<WhatsApp />}
      sx={{
        minHeight: 46,
        borderRadius: 2.5,
        bgcolor: "#218c54",
        color: "#fff",
        fontWeight: 800,
        boxShadow: "none",
        gap: 1.5,
        "&:hover": {
          bgcolor: "#176c40",
          boxShadow: "none",
        },
      }}
    >
      پشتیبانی از طریق واتساپ
    </Button>

    <Button
      fullWidth
      variant="outlined"
      component="a"
      href={`mailto:${supportEmail}?subject=${encodeURIComponent("درخواست پشتیبانی زومیو")}`}
      startIcon={<EmailOutlined />}
      sx={{
        minHeight: 46,
        borderRadius: 2.5,
        borderColor: "grey.300",
        color: "text.primary",
        fontWeight: 800,
        gap: 1.5,
        "&:hover": {
          borderColor: "#8257ac",
          bgcolor: "#f8f5fc",
        },
      }}
    >
      ارسال ایمیل
    </Button>
  </Stack>
</Paper>

    </Container>
  );
}
